import React, {Component, useEffect} from 'react'
import OrderDetailsView from './OrderDetailsView';
import {connect, useDispatch, useSelector} from "react-redux";
import {getFotografiaPlanta, getServiceOrderDetail, getTempoEtapas} from "../../actions/orderActions";
import {changeFilter} from "../../actions/FilterActions";
import {getEstacoesTrabalho, getProcessos} from "../../actions/i4Actions";
import {getTireBands} from "../../actions/tireActions";
const NA = 'N/A';

const selectTireDetails = ({ pneuModelo, pneuMedida, marcaFogo, dot, vida, banda, itemBandaAplicada, ordemServicoSequencia }) => ({
    fabricante: (pneuModelo && pneuModelo.pneuFabricante)? pneuModelo.pneuFabricante.descricao : NA,
    modelo: pneuModelo? pneuModelo.descricao : NA,
    medida: pneuMedida? pneuMedida.descricao : NA,
    marcaFogo: marcaFogo,
    dot: dot,
    ordemServicoSequencia: ordemServicoSequencia,
    vida: vida,
    banda: banda? banda.descricao : NA,
    itemBandaAplicada: itemBandaAplicada? itemBandaAplicada.descricao : ''
})

const selectOrderStatus = orderDetails => {

    let peat;
    if (orderDetails && orderDetails.processo && orderDetails.processo.processoEtapas ) {
        peat = orderDetails.processo.processoEtapas.find(pe => pe.id === orderDetails.etapaAtual);
        if (peat == null) { peat = { descricao: NA }; }
    } else  peat = { descricao: NA }
   return {
        os: orderDetails? orderDetails.ordemServicoId : 0,
        ordemServicoSequencia: orderDetails.ordemServicoSequencia,
        //situacao: orderDetails? orderDetails.situacaoOrdemServicoId : NA,
        processo: orderDetails? (orderDetails.processo? orderDetails.processo.descricao : NA) : NA,
        DTChegada: orderDetails? orderDetails.DTChegada : NA,
        DTInicioProducao: orderDetails? orderDetails.DTInicioProducao : NA,
        DTFimProducao: orderDetails? orderDetails.DTFimProducao : NA,
        DTSaida: orderDetails? orderDetails.DTSaida : NA,
        modifiedOn: orderDetails? orderDetails.modifiedOn : NA,
        etapaAtual: orderDetails? orderDetails.etapaAtual : NA,
        etapa: peat.descricao? peat.descricao : NA,
        teveRetrabalho: orderDetails? orderDetails.teveRetrabalho: NA,
        situacao: orderDetails? orderDetails.statusOrdemServico? orderDetails.statusOrdemServico.descricao : NA : NA,
        id: orderDetails? orderDetails.id : NA,
        legadoPneuFabricante: orderDetails? orderDetails.legadoPneuFabricante : NA,
        legadoPneuModelo: orderDetails? orderDetails.legadoPneuModelo : NA,
        legadoBanda: orderDetails? orderDetails.legadoBanda : NA,
        legadoBandaLargura: orderDetails? orderDetails.legadoBandaLargura : NA,
        legadoOrdemServicoSequencia: orderDetails? orderDetails.legadoOrdemServicoSequencia : NA,
        legadoDHProducao: orderDetails? orderDetails.legadoDHProducao : NA,
        legadoDHFaturamento: orderDetails? orderDetails.legadoDHFaturamento : NA,
        legadoProduzido: orderDetails? orderDetails.legadoProduzido : NA,
        legadoFaturado: orderDetails? orderDetails.legadoFaturado : NA,
        legadoRecusado: orderDetails? orderDetails.legadoRecusado : NA,
        legadoLocalizacao: orderDetails? orderDetails.legadoLocalizacao : NA,

    }
}

const selectProcessDetails = ({ processo, ordemServicoEtapas }) => {

    if (!ordemServicoEtapas) { ordemServicoEtapas = []; }

    return (
        {
            name: "Processo Padrão",
            description: processo && processo.descricao,

            steps: !ordemServicoEtapas? [] :
                ordemServicoEtapas && ordemServicoEtapas
                .sort(function(a, b) {
                    if (!a.DTInicioProducao) { return 0; }
                    if (a.DTInicioProducao < b.DTInicioProducao) { return -1; }
                    if (a.DTInicioProducao > b.DTInicioProducao) { return 1; }
                    return 0;

                    // if (!a.processoEtapa) { return 0; }
                    // if (a.processoEtapa.sequencia < b.processoEtapa.sequencia) { return -1; }
                    // if (a.processoEtapa.sequencia > b.processoEtapa.sequencia) { return 1; }
                    // return 0;
                })
                .map(step => {
                    console.log(" index step", step);

                    return ({
                                id: step.id,
                                name: step.descricao,
                                descricao: step.processoEtapa? step.processoEtapa.descricao : 'SEM.PROC.ETAPA',
                                DTChegada: step.DTChegada,
                                DTInicioProducao: step.DTInicioProducao,
                                DTFimProducao: step.DTFimProducao,
                                questions: step.ordemServicoEtapaQuestaos,
                                operadorId: step.operadorId,
                                operador: step.operador? step.operador: null,
                                raspaCycles: [], //step.raspaCycle
                                ordemServicoEtapa: step,
                                observacoes: step.observacoes,
                                estacaoTrabalhoId: step.estacaoTrabalhoId
                              });
                })
        }
    );
}


const customerDetails = (cliente) => ({
  legadoId: cliente? cliente.legadoId : NA,
  nome: cliente? cliente.descricao : NA,
  cpfcnpj: cliente? cliente.cpfcnpj : NA
})

const  OrderDetails = (props) =>  {
    const orderDetails = useSelector( st => st.ordemServicoReducer.ordemServico);
    const isFetchingServiceOrder = useSelector( st => st.ordemServicoReducer.isFetchingServiceOrder);
    const filter = useSelector( st => st.filter);
    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(getTireBands());
    }, []);


    useEffect( () => {
        if ( typeof props.ordemServicoId !== "undefined" && props.ordemServicoId !== '') {
            console.log("orderdetails index useEffect props.ordemServicoId")
            dispatch(getServiceOrderDetail(props.ordemServicoId));
        }
    }, [props.ordemServicoId]);


    return (
      <OrderDetailsView
          navUrl={props.computedMatch}
          ordemServicoId={orderDetails.ordemServicoId}
          description={orderDetails.descricao || ''}
          tireDetails={selectTireDetails(orderDetails)}
          processDetails={selectProcessDetails(orderDetails)}
          orderStatus={selectOrderStatus(orderDetails)}
          customerDetails={customerDetails(orderDetails.cliente)}
          isLoading={orderDetails.isFetchingServiceOrder}
          getServiceOrderDetail={getServiceOrderDetail}
        //  estabelecimentos={this.props.filter.estabelecimentos}
      />
    );
}


export default (OrderDetails);
